<template>
  <div class="rule-form-step rule-form-step--start rule-form-step--scaling-up--step-3 flex max-w-4xl flex-col gap-5 py-5">
    <adset-name-block :entity="entity" :disabled="$parent.readonlyMode" />

    <adset-budget-block :entity="entity" :disabled="$parent.readonlyMode" />
  </div>
</template>

<script>
import RuleFormStepMixin from '@/mixins/RuleForm/Step.js';
import AdsetBudgetBlock from '@/ui/components/RuleForm/Blocks/AdsetBudgetBlock.vue';
import AdsetNameBlock from '@/ui/components/RuleForm/Blocks/AdsetNameBlock.vue';

export default {
  name: 'ScalingUpRuleFormStep3',
  components: {
    AdsetBudgetBlock,
    AdsetNameBlock,
  },
  mixins: [ RuleFormStepMixin ],
  methods:{
    validate() {
      if (!this.validateBlocks()) {
        return false;
      }

      return true;
    },
  },
};
</script>
